module.exports = __webpack_public_path__ + "static/media/dry-van-active.6f45ffb1.svg";